import React from 'react';
import { createRoot } from 'react-dom/client';
import HekateDownloadOverlay from './HekateDownloadOverlay';
window.mountHekateDownloadOverlay = function mountHekateDownloadOverlay(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('HekateDownloadOverlay: container not found:', containerId);
        return { type: 'download-overlay', unmount: () => { } };
    }
    const root = createRoot(container);
    root.render(React.createElement(HekateDownloadOverlay, props));
    return {
        type: 'download-overlay',
        unmount: () => root.unmount(),
    };
};
